import { render, staticRenderFns } from "./blank_component.vue?vue&type=template&id=f4e58cea"
import script from "./blank_component.vue?vue&type=script&lang=js"
export * from "./blank_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports